<!-- US 6920: Permissions are read-only here; changes go through the Role catalog, where they are reviewed before taking effect -->
<div class="d-flex align-items-center justify-content-between pt-2 small">
  <span>
    <mat-icon class="yellow align-middle">lock</mat-icon>
    Permissions are read-only here. To change them, edit the role's privileges
    in the Role catalog.
  </span>
  <a mat-stroked-button color="primary" routerLink="/roles" target="_blank">
    Open Role Catalog
  </a>
</div>
<div class="d-flex flex-column justify-content-between pt-2 settings-container">
  <div class="card p-0" *ngFor="let group of privGroups">
    <div class="card-header">
      {{ group.name }}
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-3" *ngFor="let privilege of group.privileges">
          <role-selection
            [roles]="privilege.roles"
            [label]="privilege.name"
            [noSubscript]="true"
            [disabled]="true"
          ></role-selection>
        </div>
      </div>
    </div>
  </div>
</div>
